import { isValidElement, useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';
import { formatPrice } from '@spotahome/soyuz-currency';

import Button from '../Button';

import styles from './BookingBar.module.scss';

const BookingBar = ({
  price = {
    amount: 0,
    currencyCode: 'EUR',
    monthly: false,
    exact: false,
    details: false
  },
  button = {
    label: trans('property_show.book_now_card.request'),
    disabled: false,
    onClick: () => {}
  },
  className = '',
  upperPriceLabel = '',
  underPriceLabel = '',
  showPrice = true,
  isFixed = true
}) => {
  const formattedPrice = useMemo(
    () =>
      (typeof price.amount === 'number' &&
        formatPrice(price.amount, price.currencyCode)) ||
      (typeof price.amount === 'object' &&
        formatPrice(
          `${price.amount.min}-${price.amount.max}`,
          price.currencyCode
        )) ||
      price.amount,
    [price.amount, price.currencyCode]
  );

  const bookingBarPriceClasses = classNames(
    styles['booking-bar__price'],
    { [styles['booking-bar__price-hint']]: !showPrice },
    price.className
  );

  const bookingBarClasses = classNames(
    styles['booking-bar'],
    { 'booking-bar--fixed': isFixed },
    className
  );
  return (
    <div className={bookingBarClasses}>
      {!showPrice && (
        <div className={styles['booking-bar__message']}>
          <span>{trans('property_show.book_now_card.select_dates')}</span>
        </div>
      )}
      {showPrice &&
        ((isValidElement(price) && price) || (
          <div className={bookingBarPriceClasses}>
            <div>
              {upperPriceLabel ||
                (!price.exact && (
                  <span>{trans('rentable_unit_price.label.from')}</span>
                )) ||
                (!price.monthly && (
                  <span>
                    {trans('property_show.book_now_card.postpaid.total')}
                  </span>
                ))}

              <span className={styles['booking-bar__price-number']}>
                {formattedPrice}
              </span>

              {underPriceLabel ||
                (price.monthly && (
                  <span>{trans('property_show.book_now_card.per_month')}</span>
                ))}
            </div>
            {price.hint ? (
              <span className={styles['booking-bar__price-hint-inside-price']}>
                {trans('property_show.book_now_card.select_dates.exact_prices')}
              </span>
            ) : null}
          </div>
        ))}
      {(isValidElement(button) && button) || (
        <Button
          data-test="bookingBarButton"
          className={classNames(
            styles['booking-bar__button'],
            button.className
          )}
          size="medium"
          disabled={button.disabled}
          // eslint-disable-next-line react/jsx-handler-names
          onClick={button.onClick}
        >
          {button.label}
        </Button>
      )}
    </div>
  );
};

BookingBar.propTypes = {
  className: PropTypes.string,
  price: PropTypes.oneOfType([
    PropTypes.shape({
      amount: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.shape({
          min: PropTypes.number,
          max: PropTypes.number
        })
      ]),
      currencyCode: PropTypes.string,
      monthly: PropTypes.bool,
      exact: PropTypes.bool,
      className: PropTypes.string
    }),
    PropTypes.node
  ]),
  button: PropTypes.oneOfType([
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
      className: PropTypes.string
    }),
    PropTypes.node
  ]),
  upperPriceLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  underPriceLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showPrice: PropTypes.bool,
  isFixed: PropTypes.bool,
  offers: PropTypes.arrayOf(
    PropTypes.shape({
      discountType: PropTypes.string.isRequired,
      discountValue: PropTypes.number.isRequired,
      minStay: PropTypes.number.isRequired,
      maxStay: PropTypes.number
    })
  )
};
export default BookingBar;
